import React, { useContext } from 'react'
import { context } from '~/state/detailContext'
import DetailCardTitle from './DetailCardTitle'
import DetailCardIcon from './DetailCardIcon'
import DetailCardDetails from './DetailCardDetails'

const DetailCard = (): JSX.Element | null => {
  const { reference, setCardReference } = useContext(context)

  if (!reference) {
    return null
  }

  const {
    position: [x, y],
  } = reference

  const handlePointerEnter = (): void => {
    setCardReference(reference)
  }

  const handlePointerLeave = (): void => {
    setCardReference(undefined)
  }

  return (
    <div
      style={{ left: x, top: y }}
      className="detail-card"
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
    >
      <svg className="detail-card-icon">
        <DetailCardIcon reference={reference} />
      </svg>
      <div className="detail-card-contents">
        <DetailCardTitle reference={reference} />
        <DetailCardDetails reference={reference} />
      </div>
      <style jsx>{`
        .detail-card {
          opacity: 0.5;
          z-index: 7;
          position: fixed;
          width: 300px;
          border-radius: 6px;
          border: 2.5px solid #333;
          background: #fff;

          animation-name: cardappear;
          animation-duration: 350ms;
          animation-timing-function: ease-in;
          animation-fill-mode: forwards;
        }

        @keyframes cardappear {
          from {
            max-height: 0px;
          }
          to {
            max-height: 500px;
          }
        }

        .detail-card-icon {
          position: absolute;
          top: -20.5px;
          left: 10.5px;
          overflow-y: visible;
          pointer-events: none;
        }

        .detail-card-contents {
          box-sizing: border-box;
          width: 100%;
          padding: 2px;
          padding-bottom: 6px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          overflow: hidden;
        }
      `}</style>
    </div>
  )
}

export default DetailCard
